import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "TEXT_VARIABLE", {
  EDITED: "Text variable edited succesfully",
  DELETED: "Text variable deleted succesfully",
});
